import { useEffect, useState } from "react";
import { faGift } from "@fortawesome/pro-solid-svg-icons";
import { Popover, Stack, Title } from "@mantine/core";

import { Sticker } from "@components/Sticker";
import { recoverBrowserSecurityError } from "@utils";

import { FooterIcon } from "@pages/dashboard/components/FooterIcon";

const CURRENT_VERSION = {
  key: "changelog_seen_may_2022_release_notes",
  body: (
    <Stack>
      <Title order={2} size="h3" weight="normal">
        What's new with Semgrep?
      </Title>
      <Sticker
        title="Release notes: May 2022"
        linkTo="https://semgrep.dev/docs/release-notes/#may-2022?utm_source=22MayReleaseNotes&utm_medium=app&utm_id=0x13"
      >
        See the latest updates in Semgrep App and Semgrep CLI!
      </Sticker>
      <i
        style={{
          marginTop: "var(--global-spacing-m)",
          fontSize: "var(--global-font-size-xs)",
        }}
      >
        Psst, expected a gift but all you got were release notes? Please accept{" "}
        <a
          href="https://imgur.com/fgzS60Q"
          target="_blank"
          rel="noopener noreferrer"
        >
          this otter
        </a>{" "}
        gift instead.
      </i>
    </Stack>
  ),
};

const FUTURE_VERSION = {
  key: "changelog_seen_june_2022_release_notes",
  body: (
    <Stack>
      <Title order={2} size="h3" weight="normal">
        What's new with Semgrep?
      </Title>
      <Sticker
        title="Release notes: June 2022"
        linkTo="https://semgrep.dev/docs/release-notes/#june-2022?utm_source=22JuneReleaseNotes&utm_medium=app&utm_id=0x13"
      >
        See the latest updates in Semgrep App and Semgrep CLI!
      </Sticker>
      <i
        style={{
          marginTop: "var(--global-spacing-m)",
          fontSize: "var(--global-font-size-xs)",
        }}
      >
        Psst, expected a gift but all you got were release notes? Please accept{" "}
        <a
          href="https://imgur.com/t/cute/Jx6xHXy"
          target="_blank"
          rel="noopener noreferrer"
        >
          a consolation peanut
        </a>{" "}
        instead.
      </i>
    </Stack>
  ),
};

export const IS_FUTURE_VERSION_LIVE = new Date() >= new Date("July 11, 2022");

const CHANGELOG_SEEN_KEY = IS_FUTURE_VERSION_LIVE
  ? FUTURE_VERSION.key
  : CURRENT_VERSION.key;

const CHANGELOG_CONTENT = IS_FUTURE_VERSION_LIVE
  ? FUTURE_VERSION.body
  : CURRENT_VERSION.body;

export const Changelog = () => {
  const [unread, setUnread] = useState(false);
  const [opacity, setOpacity] = useState(1);
  useEffect(() => {
    const changelogSeen = recoverBrowserSecurityError(() =>
      localStorage.getItem(CHANGELOG_SEEN_KEY)
    );
    if (!changelogSeen) setUnread(true);
  }, []);

  useEffect(() => {
    if (!unread || !IS_FUTURE_VERSION_LIVE) return;
    let flashCounter = 1;
    const numFlashes = 5;
    const interval = window.setInterval(() => {
      setOpacity((current) => (current === 1 ? 0.1 : 1));
      if (flashCounter++ >= numFlashes * 2) clearInterval(interval);
    }, 500);
  }, [unread]);

  return (
    <Popover
      width={300}
      withArrow
      withinPortal
      onOpen={() => {
        recoverBrowserSecurityError(() =>
          localStorage.setItem(CHANGELOG_SEEN_KEY, "true")
        );
        setUnread(false);
      }}
    >
      <Popover.Target>
        <div>
          <FooterIcon
            style={{ opacity: opacity }}
            icon={faGift}
            highlight={unread}
            text={unread ? "New updates!" : undefined}
          />
        </div>
      </Popover.Target>
      <Popover.Dropdown>{CHANGELOG_CONTENT}</Popover.Dropdown>
    </Popover>
  );
};
